<template>
  <div class="g-grid-container" :style="{
    left: rowLabelWidth,
    width: `${100 - rowLabelWidth.replace('%', '')}%`
  }">

    <div v-for="(hour, index) in allHours" :key="index" style="flex: 1;position: relative" class="flex" :class="{
      'g-grid-line': true,
    }">
      <template v-if="timex<24&&timex>=1">
        <div v-for="i in timex" :key="i" class="flex1 " :style="{'transform':'translate(-50%)'}"
          :class="{'hour-work':(hour.text+i)>9&&(hour.text+i)<=18&&timex>=1&&getDay(hour.fullDatetime)!=5&&getDay(hour.fullDatetime)!=6}">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'GGanttGrid',


  props: {
    chartStart: { type: String },
    chartEnd: { type: String },
    rowLabelWidth: String,
    timex: { type: Number, default: 4 }
  },

  computed: {
    allHours () {
      let x = []
      if (this.timex != 24) {
        this.$store.state.mesStore.axisDays.forEach(item => {
          item.ganttHours.forEach(it => {
            it['width'] = item.widthPercentage / item.ganttHours.length
            x.push(it)
          })
        })
      } else {
        this.$store.state.mesStore.axisMonths.forEach(item => {
          item.ganttDays.forEach(it => {
            it['width'] = item.widthPercentage / item.ganttDays.length
            x.push(it)
          })
        })
      }

      return x
    },
    gridHours () {
      return moment(this.chartStart).diff(this.chartEnd, 'h')
    }
  },
  methods: {
    getDay (date) {
      return moment(date).weekday()
    }
  }
}
</script>

<style scoped>
.g-grid-container {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  height: calc(100% - 23px);
  box-sizing: border-box;
  /* justify-content: space-between; */
}

.g-grid-line {
  box-sizing: border-box;
  border: 1px solid #eaeaea;
  border-right: 1px solid transparent;
  height: 100%;
}

.g-grid-arbeiten {
  position: absolute;
  height: 100%;
  width: 100%;
}

.hour-work {
  background-color: #fffadf;
}
</style>
